'use client';

import { useEffect, useState } from 'react';
import { JournalEntryForm } from '@/modules/comptabilitat/components/JournalEntryForm';
import { JournalTable } from '@/modules/comptabilitat/components/JournalTable';
import { useAuth } from '@/auth/AuthContext';
import apiClient from '@/core/apiClient';

export default function JournalEntries() {
  const { user } = useAuth();
  const companyId = user?.companyId;
  const [showForm, setShowForm] = useState(false);
  const [entries, setEntries] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadEntries = async () => {
      if (!companyId) return;

      setLoading(true);
      setError(null);
      try {
        const response = await apiClient.get('/comptabilitat/journal-entries');
        const data = response?.data?.data || [];
        setEntries(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('[v0] Error loading journal entries:', err);
        setError(err instanceof Error ? err.message : 'Error en carregar els assentaments');
      } finally {
        setLoading(false);
      }
    };

    loadEntries();
    setShowForm(false);
  }, [companyId]);

  const handleAddEntry = async (data: any) => {
    setLoading(true);
    try {
      const response = await apiClient.post('/comptabilitat/journal-entries', data);
      console.log('[v0] New entry saved:', response);

      const updatedResponse = await apiClient.get('/comptabilitat/journal-entries');
      const updatedData = updatedResponse?.data?.data || [];
      setEntries(Array.isArray(updatedData) ? updatedData : []);
      setShowForm(false);
    } catch (err) {
      console.error('[v0] Error saving entry:', err);
      setError(err instanceof Error ? err.message : 'Error en desar l\'assentament');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold mb-2">Assentaments Comptables</h1>
        <p className="text-gray-600">Gestió d'assentaments diaris de comptabilitat</p>
      </div>

      {error && (
        <div className="p-4 bg-red-100 text-red-700 rounded">
          Error: {error}
        </div>
      )}

      {showForm && (
        <div className="border p-4 rounded bg-gray-50">
          <JournalEntryForm onSubmit={handleAddEntry} isLoading={loading} />
          <button
            onClick={() => setShowForm(false)}
            className="mt-2 px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel·lar
          </button>
        </div>
      )}

      {!showForm && (
        <button
          onClick={() => setShowForm(true)}
          className="px-4 py-2 bg-green-500 text-white rounded"
          disabled={loading}
        >
          + Nou Assentament
        </button>
      )}

      <JournalTable entries={entries} isLoading={loading} />
    </div>
  );
}
